import { TwoStepResetPassword } from './TwoStepResetPassword.js';
export default TwoStepResetPassword;
//# sourceMappingURL=index.js.map